import styled from 'styled-components';

import { lighten } from '@savgroup-front-common/primitive/helpers/cssColor';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.newUI.defaultColors.heading};
  padding: ${spacing('sm')} ${spacing('lg')};
  height: ${spacing(16)};
`;

export const $ProfilButtonContainer = styled.div`
  position: relative;
  > div {
    margin-right: ${spacing('xxs')};
  }

  margin-left: auto;
`;

export const $ProfilButton = styled.button`
  outline: 0;
  border: none;
  height: 100%;

  display: flex;
  align-items: center;

  min-width: ${spacing(12)};
  justify-content: center;
  cursor: pointer;
  transition-duration: ${({ theme }) => theme.interactions.basicTiming};
  transition-property: background-color;

  &:focus,
  &:hover {
    background-color: unset;
  }

  position: relative;
  background-color: unset;

  font-weight: ${fontWeight('bold')};

  & > div > div {
    transition-duration: ${({ theme }) => theme.interactions.basicTiming};
    transition-property: background-color;
    background-color: ${({ theme }) =>
      theme.newUI.variationColors?.light5} !important;
    color: ${({ theme }) => theme.newUI.defaultColors.heading} !important;
  }

  &:hover > div > div {
    background-color: ${({ theme }) =>
      lighten(0.05, theme.newUI.variationColors?.light5)} !important;
    color: ${({ theme }) => theme.colors.headingTextColor} !important;
  }
`;
